import { render, staticRenderFns } from "./AdminGroupAddPopup.vue?vue&type=template&id=193bb54c&scoped=true&"
import script from "./AdminGroupAddPopup.vue?vue&type=script&lang=js&"
export * from "./AdminGroupAddPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193bb54c",
  null
  
)

export default component.exports